import * as React from 'react';

import { useMountSettings } from '../../HrdsSettings/MountSettings';
import { canUseDOM } from '../../lib/canUseDOM';
import type { PopupProps } from '../Popup.types';

const isCanUseDOM = canUseDOM();

function usePopupScope(params?: { scope?: PopupProps['scope'] }) {
    const { popupContainer } = useMountSettings();

    return {
        popupScope: React.useMemo<PopupProps['scope']>(() => {
            if (params?.scope) return params?.scope;
            if (!isCanUseDOM) return undefined;
            return { current: popupContainer };
        }, [popupContainer, params?.scope]),
    };
}

function isPopupScopeExist(
    popupScope: PopupProps['scope'],
): popupScope is { current: HTMLElement } {
    return Boolean(popupScope && typeof popupScope !== 'string' && popupScope.current);
}

export { usePopupScope, isPopupScopeExist };
